import { Icon } from '@iconify/react';
import { useState } from 'react';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { copyToClipboard } from '@/Domain/utils/copyToClipboard';

type Props = {
  code: Record<string, unknown>;
};

export const Snippet = ({ code }: Props) => {
  const [copied, setCopied] = useState(false);

  const jsonString = JSON.stringify(code, null, 2);

  return (
    <div className="relative bg-foreground flex text-white p-3 rounded-lg w-full">
      <pre className="text-xs leading-4 overflow-x-auto w-full">
        <code>{jsonString}</code>
      </pre>
      <Button
        size="icon"
        className="text-white hover:bg-muted-foreground absolute bottom-3 right-3"
        variant="custom"
        onClick={() => copyToClipboard(jsonString, () => setCopied(true))}
      >
        {copied ? <Icon icon="mingcute:checks-fill" /> : <Icon icon="mingcute:copy-fill" />}
      </Button>
    </div>
  );
};
